import DataSection from "./Components/DataSection";
import { Trans, useTranslation } from "react-i18next";
import Select from 'react-select'
import { useEffect, useRef, useState } from "react";
import WorldMap from "./Components/WorldMap/WorldMap";
import SubSectionsContainer from "./SubSections/SubSectionsContainer";
import { Sections } from "../../util/types";
import { IRepresentacion } from "../../interfaces/Representacion";
import { getListaRepresentaciones } from "../../api/representation";
import { getLastUpdate } from "../../util/generic";
import { useParams } from "react-router";

const Home = () => {

  let { code } = useParams();
  
  const { t, i18n } = useTranslation("translation", { keyPrefix: "home" });

  const [activeSection, setActiveSection] = useState<Sections>("intro");

  const [listaPaises, setListaPaises] = useState<IRepresentacion[]>()
  const [pais, setPais] = useState<IRepresentacion>()

  const displayContainer = useRef<HTMLDivElement>(null);

  const date=getLastUpdate(1, i18n.language)

  useEffect(() => {
    getListaRepresentaciones(i18n.language)
      .then((res) => {
        setListaPaises(res)
        if(!code) {
          return
        }
        res.forEach(element => {
          if(element.codigo_Unidad === code) {
            setPais(element)
          }
        });
      })
      return () => {
        setListaPaises(undefined)
        setActiveSection("intro")
        setPais(undefined)        
      }
  }, [code, i18n.language])

  useEffect(() => {
    displayContainer.current?.scrollIntoView({behavior:"smooth"});
  }, [activeSection])

  const refreshActiveSection = (section:Sections) => {
    if(activeSection === section) {
      setActiveSection("intro")
      return
    }
    setActiveSection(section);    
  }

  const setPaisFromMap = (code: string) => {
    if(!listaPaises)
      return

    listaPaises.forEach(element => {
      if(element.codigo_Unidad === code) {
        setPais(element)
        return
      }
    });
  }

  return (
    <>
      <div className="row text-center mt-5 mb-2 pagetitle">
        <h2>{t('coop_tecnica')}</h2>
      </div>
      <div className="row">
        <div className="col-md-4">
          <div className="card">
            <div className="card-body">
              <WorldMap setPaisFromCode={setPaisFromMap} pais={pais} />
              <hr />
              <div>
              <Select options={listaPaises}
                value={pais}
                onChange={(newValue) => { setPais(newValue!) }} placeholder={t("buscar")}
                getOptionValue={(option) => `${option['codigo_Unidad']}`}
                getOptionLabel={(option) => `${option.pais}`}
                isClearable
              />
              </div>
            </div>
          </div>
        </div>
        <DataSection pais={pais?.codigo_Unidad} refreshActiveSection={refreshActiveSection} activeSection={activeSection}/>
      </div>
      <div ref={displayContainer}>
        <SubSectionsContainer code={pais?.codigo_Unidad} section={activeSection} />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Trans i18nKey="home.last_update" values={{date:date}}>
            <small>Última actualización: </small>
          </Trans>
        </div>
      </div>      
    </>
  );
};

export default Home;
